module.exports = __webpack_public_path__ + "static/media/calendar-off.337ca729.svg";